import React from "react";

function SectionWrapper({ children }) {
  return (
    <div>
      {children}
      <hr className="px-5" />
    </div>
  );
}

export default SectionWrapper;
